import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import CartButton from '../../components/feature/CartButton';

export default function AboutPage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/2348154358746', '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg" 
                alt="Organic Natural Solution Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>Home</Link>
              <Link to="/about" className="text-sm font-medium text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>About</Link>
              <Link to="/products" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>Products</Link>
              <Link to="/testimonials" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>Testimonials</Link>
              <Link to="/blog" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>Blog</Link>
              <Link to="/contact" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>Contact</Link>
              <CartButton />
            </div>
            <div className="flex md:hidden items-center gap-4">
              <CartButton />
              <button 
                className="cursor-pointer"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg">
            <div className="px-6 py-4 space-y-4">
              <Link to="/" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Home</Link>
              <Link to="/about" className="block text-sm font-medium text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>About</Link>
              <Link to="/products" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Products</Link>
              <Link to="/testimonials" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Testimonials</Link>
              <Link to="/blog" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Blog</Link>
              <Link to="/contact" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Contact</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              About <span className="text-teal-600">Organic Natural Solution</span>
            </h1>
            <p className="text-xl text-gray-600">
              Bringing ancient Ayurvedic wisdom to modern wellness through premium herbal remedies
            </p>
          </div>
        </div>
      </section>

      {/* Our Journey */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Journey</h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                We seek to provide people with the ultimate solution for all health problems in Complementary and Alternative medicine, Herbal medicine, Naturopathy, Ayurveda, personal care, Herbal skincare and various health care products.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                Our system is one of the world\'s oldest holistic (whole-body) healing systems, developed over 3,000 years ago in India. We believe that health and wellness depend on a delicate balance between the Mind, Body & Spirit.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Our products were founded with divine blessing, manufacturing since 1993 and expanding into Multi-Level Marketing in 2019. We offer ISO 9001:2015, GMP (Good Manufacturing Practice), FDA and NAFDAC certified products through well-researched and scientifically proven manufacturing practices.
              </p>
            </div>
            <div className="rounded-3xl overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/0e492a62ad323cc15462e0afb442950e.jpg" 
                alt="Our Journey" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Core Values</h2>
            <p className="text-lg text-gray-600">The principles that guide everything we do</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-leaf-line',
                title: 'Purity',
                description: '100% organic ingredients sourced from trusted farms'
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Quality',
                description: 'Rigorous testing and quality control at every step'
              },
              {
                icon: 'ri-heart-line',
                title: 'Care',
                description: 'Dedicated to your wellness journey and success'
              },
              {
                icon: 'ri-earth-line',
                title: 'Sustainability',
                description: 'Environmentally responsible sourcing and packaging'
              }
            ].map((value, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full mx-auto mb-6">
                  <i className={`${value.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-teal-600">
        <div className="max-w-4xl mx-auto px-6 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Ready to Transform Your Health?</h2>
          <p className="text-xl mb-8 text-teal-50">
            Join thousands of satisfied customers on their wellness journey
          </p>
          <Link to="/products" className="inline-block bg-white text-teal-600 px-10 py-4 rounded-full font-medium hover:bg-gray-100 transition-colors whitespace-nowrap">
            Shop Now
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div>
              <img src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg" alt="Organic Natural Solution Logo" className="h-12 w-auto mb-6" />
              <p className="text-gray-400 leading-relaxed mb-6">
                Dedicated to providing the highest quality herbal remedies that honor traditional wisdom while meeting modern wellness needs.
              </p>
              <div className="flex gap-4">
                <a href="https://www.instagram.com/healthyliving.products?igsh=NGl6a3oxZXhrcmxr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="https://www.facebook.com/share/1CKjLukjVr/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
              </div>
            </div>

            <div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">LOCATION</h4>
                <p className="text-gray-400">#2 Allen Avenue Near Tonyin Roundabout, Ikeja, Lagos - Nigeria</p>
              </div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">PHONE</h4>
                <p className="text-gray-400">+234 815 435 8746</p>
                <p className="text-gray-400">+234 913 789 7299</p>
              </div>
              <div>
                <h4 className="text-xs font-bold uppercase mb-3">EMAIL</h4>
                <p className="text-gray-400">healthyliving.hello@gmail.com</p>
              </div>
            </div>

            <div>
              <div className="rounded-2xl overflow-hidden h-80">
                <img 
                  src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/6686b80771a03e2f4f8c9b19d31144a1.jpeg" 
                  alt="Organic Natural Solution" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8">
            <p className="text-sm text-gray-400 text-center">© 2025 Organic Natural Solution. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center z-50 transition-all hover:scale-110 cursor-pointer"
        aria-label="Contact us on WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </button>
    </div>
  );
}
